import React from 'react';
import PropTypes from 'prop-types';

import BaseReviewForm from 'AppComponents/BaseReview/ReviewForm';
import RatingInput from 'AppComponents/RatingInput/Formsy';


const ReviewForm = ({ charger, newReviewSuccess, reviewStatus, numReviews }) => (
  <BaseReviewForm
    newReviewApiEndpoint={`charger/${charger.pk}/reviews/`}
    newReviewSuccess={newReviewSuccess}
    numReviews={numReviews}
    reviewStatus={reviewStatus}
    type='charger'
  >

    <RatingInput
      name='rating'
      label='Rating'
      min='0'
      max={5}
      validations={{
        matchRegexp: /^[12345]$/,
      }}
      disabled={!reviewStatus.can_review}
      required
    />

  </BaseReviewForm>
);

ReviewForm.propTypes = {
  charger: PropTypes.shape({ pk: PropTypes.number }).isRequired,
  newReviewSuccess: PropTypes.func,
  numReviews: PropTypes.number,
  reviewStatus: PropTypes.shape({ can_review: PropTypes.bool }).isRequired,
};

ReviewForm.defaultProps = {
  newReviewSuccess: () => {},
  numReviews: null,
};

export default ReviewForm;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Charger/components/ReviewForm/index.jsx